import {Grid} from "@mui/material";
import React from "react";

function Heading({title}) {
    return <>
        <Grid item xs={12} md={6} style={{display: "flex", flexDirection: 'column', justifyContent: "flex-start"}}>
            <div className={"line"}/>
            <h1>{title}</h1>
        </Grid>

    </>
} export default Heading;